// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"ea5a95d8","453":"c110518b","517":"e6d01504","659":"1ea6528e","701":"7d1d5bde"}[chunkId] + ".chunk.js";
};